import React, { useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { SnackbarContext } from "./SnackbarContext";

export const SnackbarProvider = ({ children }) => {
  // Snackbarに与えるパラメータをstateで管理
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("info");
  const [message, setMessage] = useState("");

  /**
   *
   * スナックバーを表示する
   * @param {string} type スナックバーの種類（"error" | "warning" | "info" | "success"）
   * @param {string} message メッセージ
   * @memberof SnackbarProvider
   */
  const showSnackbar = (type, message) => {
    setOpen(true);
    setSeverity(type);
    setMessage(message);
  };

  /**
   * snackbarのxボタンが押された時のコールバック関数
   * @param {any} _
   * @param {string} reason 閉じる処理の種類
   * @memberof SnackbarProvider
   */
  const handleClose = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <React.Fragment>
      {/* 子コンポーネントの描画 */}
      <SnackbarContext.Provider value={{ showSnackbar: showSnackbar }}>
        {children}
      </SnackbarContext.Provider>
      {/* Snackbarの描画 */}
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          <span style={{ whiteSpace: "pre-wrap" }}>{message}</span>
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
};
